export default __webpack_public_path__ + "static/bg-cs-zappi-5b76722d0b778fad9ee11c03b1b696e4.jpg";